import { render, staticRenderFns } from "./ChoiceEdit.vue?vue&type=template&id=356a82fa&scoped=true"
import script from "./ChoiceEdit.vue?vue&type=script&lang=js"
export * from "./ChoiceEdit.vue?vue&type=script&lang=js"
import style0 from "./ChoiceEdit.vue?vue&type=style&index=0&id=356a82fa&prod&lang=scss&scoped=true"
import style1 from "./ChoiceEdit.vue?vue&type=style&index=1&id=356a82fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356a82fa",
  null
  
)

export default component.exports